import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { browserHistory } from 'react-router';

import SiteNav from '../SiteNav';
import ShareModal from '../ShareModal';
import AdSection from '../AdSection';
import MyEverdaysPanel from '../MyEverdaysPanel';
import MultiLineText from '@evdy/web-core/dist/components/shared/elements/MultiLineText';
import GetLinkCard from '../GetLinkCard';
import FbShareBtn from '../FbShareBtn';
import FbShareSection from '../FbShareSection';

import { getBaseRoute } from '../WebCommunity';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';
import { useScrollToTop, useFBShareRender } from '@evdy/web-core/dist/customHooks';

import styles from './ObituaryDetails.module.scss';

const { trackAds } = webCommunityOperations;

const {
  'decedent-bar-btn': decedentBarClass,
  'go-back': goBackClass,
  'obit-details': obitDetailsWrapper,
  'obit-details-content': obitContentClass,
  'ad-section': adSectionClass,
  'page-header': pageHeaderClass,
  'title-container': titleContainerClass,
  'obit-message': obitMessageClass,
  'my-everdays-panel': myEverdaysPanelClass,
  'styling-container': stylingContainerClass,
  'obit-column': obitColumnClass,
  'my-everdays-column': myEverdaysColumnClass
} = styles;

const ObituaryDetails = ({ location }) => {
  const { inviteMeta, obitMessage } = useSelector(({ webCommunity }) => ({
    inviteMeta: webCommunity.inviteMeta.data,
    obitMessage: webCommunity.inviteMeta.data?.obituary,
    eventsArray: webCommunity.events?.array
  }));

  const [isShareModalOpen, setShareModalOpen] = useState(false);

  const { _id: memorialId, ads = [], shareUrl = '' } = inviteMeta || {};

  const placementType = 'communityObituaryDetails';
  const findAdsCb = ({ placementType: adDataPlacementType }) =>
    placementType === adDataPlacementType;
  const webCommunityAdData = !!ads.length && ads.find(findAdsCb);

  const handleGoBack = () => browserHistory.push(getBaseRoute(location.pathname));

  const handleToggleShareMenu = () => setShareModalOpen(prev => !prev);

  //scroll to top on mount
  useScrollToTop();

  // parse fb share content to be visible when navigating pages
  useFBShareRender();

  const DecedentBarBtn = () => (
    <button className={decedentBarClass} onClick={handleToggleShareMenu}>
      Share
    </button>
  );

  return (
    <div className={obitDetailsWrapper}>
      <SiteNav decedentBarContent={DecedentBarBtn} showDecedentBar />
      <div className={obitContentClass}>
        <div className={stylingContainerClass}>
          <div className={obitColumnClass}>
            <div className={goBackClass} onClick={handleGoBack}>
              {'← Back'}
            </div>
            <div className={titleContainerClass}>
              <h3 className={pageHeaderClass}>Obituary</h3>
              <FbShareBtn {...{ shareUrl }} />
            </div>
            <div className={obitMessageClass}>
              <MultiLineText _blank text={obitMessage} />
            </div>
          </div>
          {/* <div className={myEverdaysColumnClass}>
            <div className={myEverdaysPanelClass}>
              <MyEverdaysPanel />
            </div>
          </div> */}
        </div>
      </div>
      <FbShareSection {...{ shareUrl }} />
      <GetLinkCard />
      <ShareModal
        closeModal={handleToggleShareMenu}
        modalVisible={isShareModalOpen}
        shareUrl={inviteMeta.shareUrl}
      />
      <div className={adSectionClass}>
        <AdSection {...{ trackAds, memorialId }} adData={webCommunityAdData} />
      </div>
    </div>
  );
};

export default ObituaryDetails;
